import CheckoutItem from '../../components/CheckoutItem'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as basketAction from '../../actions/components/basket'

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.user,
    merchant: state.merchant,
    orders: state.orders,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { updatePerItemRemark } = bindActionCreators(basketAction, dispatch)
  return {
    updatePerItemRemark,
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CheckoutItem)))



// WEBPACK FOOTER //
// ./src/containers/components/CheckoutItem.js